module.exports = __webpack_public_path__ + "img/21.b7324b4b.jpg";